import React from 'react';
import { Button } from '@mui/material';
import { useIntl } from 'react-intl';

const PrivacyPolicyPage: React.FC = () => {
  const intl = useIntl();

  React.useEffect(() => {
    document.title = intl.formatMessage({ id: 'privacyPolicy.title' });
  }, [intl]);

  return (
    <div style={{ height: '100vh', display: 'flex', flexDirection: 'column' }}>
      <div
        style={{
          padding: '12px 16px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          borderBottom: '1px solid #ddd',
        }}
      >
        <h2 style={{ margin: 0 }}>
          {intl.formatMessage({ id: 'privacyPolicy.title' })}
        </h2>

        <Button
          color="primary"
          href="/documents/privacy-policy.pdf"
          target="_blank"
          rel="noopener noreferrer"
        >
          {intl.formatMessage({ id: 'privacyPolicy.openPdf' })}
        </Button>
      </div>

      <object
        data="/documents/privacy-policy.pdf"
        type="application/pdf"
        width="100%"
        height="100%"
      >
        <div style={{ padding: 24 }}>
          <p>{intl.formatMessage({ id: 'privacyPolicy.pdfNotSupported' })}</p>
          <Button
            color="primary"
            href="/documents/privacy-policy.pdf"
            target="_blank"
            rel="noopener noreferrer"
          >
            {intl.formatMessage({ id: 'privacyPolicy.openPdf' })}
          </Button>
        </div>
      </object>
    </div>
  );
};

export default PrivacyPolicyPage;